import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactGA from "react-ga";
//MUI components
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
//custom components
import TopPerformers from "../topperformers/topperformers";
import OtherPerformers from "../otherperfromers/otherperfromers";
import Footer from "../footer/footer";

function Main(props) {
  const [topPerformersData, setTopPerformersData] = useState([
    { teamName: null, round1: null, round2: null, total: null },
    { teamName: null, round1: null, round2: null, total: null },
    { teamName: null, round1: null, round2: null, total: null },
  ]);
  const [otherPerfromersData, setOtherPerfromersData] = useState([
    { teamName: null, round1: null, round2: null, total: null },
    { teamName: null, round1: null, round2: null, total: null },
    { teamName: null, round1: null, round2: null, total: null },
  ]);
  const [topOrNot, setTopOrNot] = useState(false);
  const [tempArray, setTempArray] = useState([]);
  const [tempArray2, setTempArray2] = useState([]);
  //analytics
  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  }, []);

  //calling backend to fetch data
  useEffect(() => {
    axios
      .get("https://dataxact-backend.vercel.app/teams/getData")
      .then(function (response) {
        // handle success
        const data = response.data;
        if (data[0].round1 == null && data[1].round1 == null) {
          //round 1 is not updated
          //no need of top perfromers
          setOtherPerfromersData(data);
          setTopOrNot(false);
        } else {
          var count = 4;
          //need of top performers
          setTopPerformersData(data.slice(0, 3));
          setOtherPerfromersData(data.slice(3));
          setTopOrNot(true);
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  }, []);
  return (
    <>
      <Container sx={{ backgroundColor: "", marginTop: "0" }}>
        {/*logo*/}
        <Box
          component="img"
          src="dsc-logo.png"
          sx={{
            height: {
              xl: "6rem",
              lg: "5.5rem",
              md: "5rem",
              sm: "4.5rem",
              xs: "3rem",
            },
            marginTop: "2rem",
            display: "flex",
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "center",
            alignItems: "center",
          }}
        />
        {/*event title*/}
        <Typography
          sx={{
            lineHeight: "1.4",
            textAlign: "center",
            marginTop: "0.8rem",
            fontSize: {
              xl: "3rem",
              lg: "2.8rem",
              md: "2.5rem",
              sm: "2rem",
              xs: "1.3rem",
            },
            fontWeight: "bold",
            color: "#ffffff",
            letterSpacing: "0.3rem",
          }}
          variant="h1"
          gutterBottom
        >
          DataXact
        </Typography>
        {/*page title*/}
        <Typography
          sx={{
            textAlign: "center",
            fontSize: {
              xl: "2rem",
              lg: "1.8rem",
              md: "1.5rem",
              sm: "1.3rem",
              xs: "1rem",
            },
            color: "#ffffff",
            letterSpacing: "0.2rem",
            marginTop: "",
          }}
          variant="h2"
          gutterBottom
        >
          Leaderboard
        </Typography>
      </Container>
      {/*top perfromers*/}
      <Container fluid>
        <TopPerformers
          data={topPerformersData}
          state={topOrNot}
        ></TopPerformers>
      </Container>
      {/*other perfromers*/}
      <Container
        sx={{
          marginBottom: "",
          position: "relative",
          top: { lg: "2.5rem", md: "5rem", sm: "6.5rem", xs: "8rem" },
        }}
      >
        <OtherPerformers
          data={otherPerfromersData}
          state={topOrNot}
        ></OtherPerformers>
      </Container>
      <Footer></Footer>
    </>
  );
}
export default Main;
